import { Component, OnInit, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-compare-roles-summary-view',
    templateUrl: './compare-roles-summary-view.component.html',
    styleUrls: [
        '../../../../../../../../../src/assets/css/global-styles.scss',
        '../../../../../../../../../src/assets/css/ds-core.css',
        '../../../../../../../../../src/assets/css/ds-button.css',
        '../../../../../../../../../src/assets/css/ds-card.css',
        '../../../../../../../../../src/assets/css/ds-form.css',
        '../../../../../../../../../src/assets/css/ds-modal.css',
        '../../../../../../../../../src/assets/css/ds-step-indicator.css',
        '../../../../../../../../../src/assets/css/ds-tabs.css',
        '../../../../../../../../../src/assets/css/ds-tile.css',
        './compare-roles-summary-view.component.css',
    ],
    imports: [
    FormsModule,
    NgClass
]
})
export class CompareRolesSummaryViewComponent implements OnInit {
  constructor() {}
  currentRole: number;
  readonly dataRoleInternal = input<any[]>(undefined);

  readonly dataRoleExternal = input<any[]>(undefined);

  ngOnInit(): void {
    this.currentRole = 1;
  }
  getList(i: number): any[] {
    if (i == 1) {
      return this.dataRoleInternal();
    } else {
      return this.dataRoleExternal();
    }
  }
}
